module.exports = __webpack_public_path__ + "img/chypre.cd197988.jpeg";